import { useMutation } from "@shared/lib/hooks";
import { BriefService } from "../services/brief.service";
import { IEditBriefInvoice } from "@shared/lib/types/briefInvoice";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_INVOICE_AGGREGATION_QUERY_KEY,
  BRIEF_INVOICE_FACETS_QUERY_KEY,
  BRIEF_INVOICE_QUERY_KEY,
  BRIEF_TOTAL_AGGREGATION_QUERY_KEY,
} from "../constants";

export function useEditBriefInvoice() {
  const {
    mutate: edit,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation({
    mutationFn: (data: IEditBriefInvoice) =>
      BriefService.editBriefInvoice(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      ToastService.success("Brief invoice updated successfully");
      c.invalidateQueries({ queryKey: BRIEF_INVOICE_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_INVOICE_FACETS_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_INVOICE_AGGREGATION_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_TOTAL_AGGREGATION_QUERY_KEY });
    },
  });

  return {
    edit,
    isEditing,
    isEdited,
  };
}
